export const injectAsyncScripts = () => {
  window.recaptchaPromise = new Promise(function (resolve) {
    window.onGRecaptchaLoad = () => {
      resolve();
    };
  });
  try {
    const asyncScripts = [
      "https://www.google.com/recaptcha/api.js?onload=onGRecaptchaLoad&render=explicit",
      "https://tags.tiqcdn.com/utag/vodafone/za-microservice/prod/utag.sync.js"
    ];
    const a = "script";
    for (let i = 0; i < asyncScripts.length; i++) {
      const s = document.createElement(a);
      s.type = "text/javascript";
      s.async = true;
      s.src = asyncScripts[i];
      const x = document.getElementsByTagName(a)[0];
      x.parentNode.insertBefore(s, x);
    }
  } catch (e) {
    console.error(e);
  }
};
